import cookie from "cookie";
import { get } from "lodash";
import {
  hasStoryAccess as hasStoryAccessApi,
  incrementPremiumStoriesRead as incrementPremiumStoriesReadCountApi
} from "./api";
import { isPremium } from "./data/story";
import { RazorPay } from "./integrations";
import Cookie from "universal-cookie";

function getStoriesReadFromLocalStorage() {
  if (global.localStorage) {
    return JSON.parse(global.localStorage.getItem("premiumStoriesRead") || '{"storyIds": []}');
  }

  return {
    storyIds: []
  };
}

const excludeTags = [
  "coronavirus",
  "vikatan-updates",
  "my-vikatan-roi",
  "cinema-vikatan-videos",
  "nri-kids-creation",
  "suda-suda",
  "say-swag",
  "my-vikatan",
  "vikatan-tv",
  "ipl-2020",
  "ipl-2021",
  "sponsor-content",
  "sanipeyarchi-2020",
  "motor-vikatan"
];

function standardPaywal(resolve, reject, story, user, testgroup = "", segment = "") {
  if (!isPremium(story)) {
    resolve({ granted: true, grantReason: "FREE", testgroup: testgroup, segment: segment });
  }

  const storiesReadCount = getStoriesReadFromLocalStorage().storyIds.length;
  const storiesAlreadyRead = getStoriesReadFromLocalStorage().storyIds.includes(story.id)
    ? storiesReadCount
    : storiesReadCount + 1;
  const remainingStoriesCount = 7 - storiesAlreadyRead;
  if (!user) {
    return resolve({
      granted: getStoriesReadFromLocalStorage().storyIds.includes(story.id) || storiesReadCount < 7,
      grantReason: "METERING LOCAL",
      remainingStoriesCount: remainingStoriesCount < 0 ? 0 : remainingStoriesCount,
      testgroup: testgroup || "",
      segment: segment
    });
  }

  hasStoryAccessApi(story.id)
    .then(function(response) {
      if (testgroup) {
        response.testgroup = testgroup;
        response.segment = segment;
      }
      if (["METERING"].includes(response.grantReason)) {
        response.granted = getStoriesReadFromLocalStorage().storyIds.includes(story.id) || storiesReadCount < 7;
        response.remainingStoriesCount = remainingStoriesCount < 0 ? 0 : remainingStoriesCount;
      }
      return resolve(response);
    })
    .catch(reject);
}

function searchTag(objects, toSearch) {
  for (let i = 0; i < objects.length; i++) {
    if (objects[i].slug && toSearch.find(element => element.toLowerCase() === objects[i].slug.toLowerCase())) {
      return true;
    }
  }
  return false;
}

function pwdeepbi(resolve, cname, story, testgroup) {
  let d = new Date();
  d.setUTCHours(18, 29, 59, 999);
  let cookiesnew = new Cookie();
  let msgShow = false;
  let granted = true;
  let type = "";
  story.access = "free";
  let cookies = cookie.parse(document.cookie);
  if (!cookies[cname] || cookies[cname] === "1") {
    story.access = "subscription";
    msgShow = true;
    granted = false;
    type = cname === "pw_welmsg" ? "welcome" : "reminder";
    !cookies[cname] && cookiesnew.set(cname, 1, { path: "/", expires: d });
  }

  resolve({
    granted: granted,
    grantReason: (granted && "FREE") || "SUBSCRIBE",
    paywall: "dynamic",
    type: type,
    msgShow: msgShow,
    testgroup: testgroup
  });
}

function dynamicpaywal(resolve, reject, story, user) {
  // Call P2S API
  let cookies = cookie.parse(document.cookie);
  global
    .wretch(`https://scoring.deep.bi/score/17cZaviwFrV2/${cookies.deepbi_user_deepcookie}?id=deepcookie&column=profile`)
    .get()
    .json(function(response) {
      const testgroup = get(response, ["testgroup"]);
      const segment = get(response, ["rfv_segment"]);
      const isTagExists = searchTag(get(story, ["tags"]), excludeTags);
      const isShortNews = get(story, ["metadata", "story-attributes", "shortnews", 0], "false") === "true";
      if (response.testgroup === "A") {
        if (isTagExists || isShortNews) {
          resolve({
            granted: true,
            grantReason: "FREE",
            paywall: "dynamic",
            testgroup: testgroup
          });
        } else if (response.welcome_message === 1) {
          pwdeepbi(resolve, "pw_welmsg", story, testgroup);
        } else if (response.user_treatment === "true") {
          pwdeepbi(resolve, "pw_reminmsg", story, testgroup);
        } else if (response.paywall_decision === 1) {
          RazorPay.loadScript();
          story.access = "subscription";
          resolve({
            granted: false,
            grantReason: "SUBSCRIBE",
            paywall: "dynamic",
            showDynamic: 1,
            testgroup: testgroup
          });
        } else {
          standardPaywal(resolve, reject, story, user, testgroup || "", segment || "");
        }
      } else {
        standardPaywal(resolve, reject, story, user, testgroup || "", segment || "");
      }
    });
}

export function hasStoryAccess(story) {
  return new Promise((resolve, reject) => {
    let cookies = cookie.parse(document.cookie);
    global.userPromise.catch(() => null).then(user => {
      if (!get(story, ["IsPaid"], null)) {
        story.IsPaid = story.access === "subscription" ? "subscription" : "free";
      }

      if (!user || (user && ["F", "E"].includes(user.userType) && !cookies.vikwl)) {
        dynamicpaywal(resolve, reject, story, user);
      } else if (user.userType) {
        standardPaywal(resolve, reject, story, user);
      }
    });
  });
}

export function incrementPremiumStoriesRead(storyId) {
  if (global.localStorage) {
    if (!storyId) {
      const storiesAlreadyRead = getStoriesReadFromLocalStorage();
      return incrementPremiumStoriesReadCountApi(storiesAlreadyRead.storyIds);
    }
    const currentDate = new Date();
    let alreadyViewedStories = new Set([]);
    const storiesAlreadyRead = getStoriesReadFromLocalStorage();
    if (storiesAlreadyRead.expiresAt > currentDate.valueOf()) {
      alreadyViewedStories = new Set(storiesAlreadyRead.storyIds);
    }
    alreadyViewedStories.add(storyId);
    global.localStorage.setItem(
      "premiumStoriesRead",
      JSON.stringify({
        storyIds: Array.from(alreadyViewedStories),
        expiresAt: new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1).valueOf()
      })
    );
    return incrementPremiumStoriesReadCountApi(storyId);
  }
}
